import { useEffect, useRef, useState, useCallback, useContext } from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { useForm } from "react-hook-form";
import ReCAPTCHA from "react-google-recaptcha";
import GoToTop from "../helpers/GoToTop";
import MetaData from "../helpers/MetaData";
import notification from "../helpers/notification";
import ApiService from "../api/ApiService";
import AppContext from "../context/AppContext";
import "../css/volunteer.scss";
import { useNavigate } from "react-router-dom";
const VolunteerSeva = () => {
    const navigate = useNavigate();
    const { user } = useContext(AppContext);
    const [top, setTop] = useState(0);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const {
        register,
        formState: { errors },
        handleSubmit,
        reset,
    } = useForm();

    const recaptchaRef = useRef();
    const opportunitiesRef = useRef();

    const onSubmitVolunteer = async (data) => {
        setIsSubmitting(true);
        try {
            const token = await recaptchaRef.current.executeAsync();
            data.token = token;

            const res = await ApiService.newVolunteer(data);

            console.log("res", res);

            if (res?.success) {
                notification("success", res.message || "Submitted successfully.");
                reset();
                recaptchaRef.current.reset();
                navigate("/volunteer/thank-you");
            } else {
                notification("error", res?.message || "Something went wrong. Please try again.");
            }

        } catch (err) {
            console.log(err);
            notification("error", err.response?.data?.message || "Something went wrong");
        } finally {
            setIsSubmitting(false);
        }
    };

    const [meta, setMeta] = useState(null);
    const fetchMeta = async (pagename) => {
        try {
            let res = await ApiService.fetchMetaData(pagename);
            setMeta(res);
        } catch (error) {
            console.log(error);
        }
    };

    const festRef = useCallback((node) => {
        if (node) {
            setTop(node.offsetTop - 45);
        }
    }, []);

    useEffect(() => {
        fetchMeta("volunteer");
    }, []);

    useEffect(() => {
        if (user) {
            reset({
                name: user.name,
                email: user.email,
                phone: user.phone,
            });
        }
    }, [user]);

    const scrollToRegistration = () => {
        const registrationSection = document.getElementById('volunteer-registration');
        if (registrationSection) {
            registrationSection.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const volunteerOpportunities = [

        {
            id: 1,
            title: "Book Distribution",
            description: "Spread Krishna consciousness by distributing spiritual literature to the public.",
            image: "/images/volunteer/volunteer-8.webp"
        },
        {
            id: 2,
            title: "Harinam Sankirtana",
            description: "Join street Harinam and spread the holy names in the community.",
            image: "/images/volunteer/volunteer-4.webp"
        },

        {
            id: 3,
            title: "Volunteer for Festival Services",
            description: "Help organize and participate in various spiritual festivals throughout the year.",
            image: "/images/volunteer/volunteer-2.webp"
        },

        //  {
        //     id: 4,
        //     title: "Food Distribution",
        //     description: "Participate in our food relief programs, bringing prasadam to those in need.",
        //     image: "/images/volunteer/volunteer-1.webp"
        // },

        //  {
        //     id: 5,
        //     title: "Community Kitchen",
        //     description: "Help prepare and distribute prasadam to devotees and visitors at the temple.",
        //     image: "/images/volunteer/community-kitchen.webp"
        // },
    ];

    const sevaCategories = [
        // "Community Kitchen",
        "Book Distribution",
        "Harinam Sankirtana",
        // "Food Distribution",
        "Volunteer for Festival Services",

        // "Temple Maintenance",
        // "Media & Communications",
        // "Medical Services",
        // "IT Support",
        // "Art & Design"
    ];

    const professionalExpertise = [
        "Medical Services",
        "Architecture & Interiors",
        "IT & Computer Management",
        "Editorial Services & Publishing",
        "Graphic Design & Fine Arts",
        "Social Media Management",
        "Photography & Filmmaking",
        "Drama & Performing Arts"
    ];

    return (
        <>
            <MetaData title="Volunteer Seva - ISKCON of Attapur" />

            {/* Hero Section */}
            <section className="volunteer-hero" >
                <div className="hero-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8 mx-auto text-center">
                                <div className="hero-badge">
                                    <span className="badge-icon">✨</span>
                                    <span>Join Our Spiritual Community</span>
                                </div>
                                <h1 className="hero-title">VOLUNTEERS SEVA</h1>
                                <p className="hero-subtitle content-justify">
                                    Join our spiritual community in service to Krishna. Every act of devotion, no matter
                                    how small, is received with love by the <span className="highlight">Lord</span>.
                                </p>
                                <button
                                    className="hero-cta-btn"
                                    onClick={scrollToRegistration}
                                    disabled={isSubmitting}
                                >
                                    START YOUR SEVA JOURNEY
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Registration Header */}
            <section className="registration-header">
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-center">
                            <h2 className="registration-title">
                                <span className="volunteer-text">VOLUNTEER</span>{" "}
                                <span className="registration-text">REGISTRATION</span>
                            </h2>
                        </div>
                    </div>
                </div>
            </section>
            {/* Registration Section */}
            <section className="volunteer-registration" id="volunteer-registration">
                <div className="container-fluid p-0">
                    <div className="row g-0">
                        {/* Left Side - Benefits */}
                        <div className="col-lg-4">
                            <div className="seva-benefits">
                                <div className="benefits-content">
                                    <h2 className="benefits-title">JOIN OUR SEVA TEAM</h2>
                                    <p className="benefits-subtitle">
                                        Fill out the form to register as a volunteer and
                                        become part of our spiritual community
                                        dedicated to serving Lord Krishna.
                                    </p>

                                    <div className="benefits-list">
                                        <div className="benefit-item">
                                            <div className="benefit-icon">
                                                <span>🌟</span>
                                            </div>
                                            <span>Experience spiritual growth</span>
                                        </div>
                                        <div className="benefit-item">
                                            <div className="benefit-icon">
                                                <span>🌟</span>
                                            </div>
                                            <span>Connect with like-minded devotees</span>
                                        </div>
                                        <div className="benefit-item">
                                            <div className="benefit-icon">
                                                <span>🌟</span>
                                            </div>
                                            <span>Make a positive impact on the society</span>
                                        </div>
                                    </div>

                                    <div className="deity-image">
                                        <img src="/images/volunteer/radha-madhava.jpeg" alt="Sri Sri Radha Madhava" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Right Side - Form */}
                        <div className="col-lg-8">
                            <div className="seva-form-section">
                                <div className="form-container">
                                    <h3 className="form-title">JOIN OUR SEVA COMMUNITY</h3>

                                    <form onSubmit={handleSubmit(onSubmitVolunteer)}>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Name Of The Volunteer <span className="required">*</span></label>
                                                    <input
                                                        type="text"
                                                        {...register("name", { required: "Name is required" })}
                                                        className={errors.name ? 'error' : ''}
                                                    />
                                                    {errors.name && <span className="error-text">{errors.name.message}</span>}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Email ID <span className="required">*</span></label>
                                                    <input
                                                        type="email"
                                                        {...register("email", {
                                                            required: "Email is required",
                                                            pattern: {
                                                                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                                                message: "Please enter a valid email"
                                                            }
                                                        })}
                                                        className={errors.email ? 'error' : ''}
                                                    />
                                                    {errors.email && <span className="error-text">{errors.email.message}</span>}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Phone Number <span className="required">*</span></label>
                                                    <input
                                                        type="tel"
                                                        {...register("phone", {
                                                            required: "Phone number is required",
                                                            minLength: { value: 10, message: "Phone number must be at least 10 digits" }
                                                        })}
                                                        className={errors.phone ? 'error' : ''}
                                                        onKeyPress={(e) => {
                                                            if (!/[0-9]/.test(e.key)) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                    />
                                                    {errors.phone && <span className="error-text">{errors.phone.message}</span>}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Seva Category <span className="required">*</span></label>
                                                    <select
                                                        {...register("sevaCategory", { required: "Please select a seva category" })}
                                                        className={errors.sevaCategory ? 'error' : ''}
                                                    >
                                                        <option value="">Select Seva Category</option>
                                                        {sevaCategories.map((category, index) => (
                                                            <option key={index} value={category}>{category}</option>
                                                        ))}
                                                    </select>
                                                    {errors.sevaCategory && <span className="error-text">{errors.sevaCategory.message}</span>}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Availability <span className="required">*</span></label>
                                                    <select
                                                        {...register("availability", { required: "Please select your availability" })}
                                                        className={errors.availability ? 'error' : ''}
                                                    >
                                                        <option value="">Select Availability</option>
                                                        <option value="weekdays">Weekdays</option>
                                                        <option value="weekends">Weekends</option>
                                                        {/* <option value="both">Both Weekdays & Weekends</option> */}
                                                        <option value="flexible">Flexible</option>
                                                    </select>
                                                    {errors.availability && <span className="error-text">{errors.availability.message}</span>}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Preferred Start Date <span className="required">*</span></label>
                                                    <input
                                                        type="date"
                                                        {...register("startDate", { required: "Please select a start date" })}
                                                        className={errors.startDate ? 'error' : ''}
                                                        placeholder="dd / mm / yyyy"
                                                        min={new Date().toISOString().split('T')[0]}
                                                    />
                                                    {errors.startDate && <span className="error-text">{errors.startDate.message}</span>}
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div className="form-group">
                                                    <label>Comments (Optional)</label>
                                                    <textarea
                                                        {...register("comments")}
                                                        placeholder="Share any additional information or specific interests..."
                                                        rows="4"
                                                    ></textarea>
                                                </div>
                                            </div>
                                        </div>

                                        <ReCAPTCHA
                                            sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
                                            ref={recaptchaRef}
                                            size="invisible"
                                        />

                                        <button
                                            type="submit"
                                            className="submit-btn"
                                            disabled={isSubmitting}
                                        >
                                            {isSubmitting ? 'SUBMITTING...' : 'SUBMIT'}
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Opportunities Section */}
            <section className="volunteer-opportunities">
                <div className="container">
                    <div className="section-header">
                        <div className="section-badge">Volunteer Opportunities</div>
                        <h2 className="section-title">OPPORTUNITIES</h2>
                    </div>

                    {/* <Splide
                        ref={opportunitiesRef}
                        className="opportunities-slider"
                        options={{
                            type: "loop",
                            perPage: 4,
                            perMove: 1,
                            gap: 30,
                            arrows: false,
                            pagination: true,
                            autoplay: true,
                            speed: 800,
                            interval: 5000,
                            breakpoints: {
                                576: { perPage: 1, gap: 20 },
                                768: { perPage: 2, gap: 20 },
                                992: { perPage: 3, gap: 25 },
                                1200: { perPage: 4, gap: 30 }
                            },
                        }}
                    >
                        {volunteerOpportunities.map((opportunity) => (
                            <SplideSlide key={opportunity.id}>
                                <div className="opportunity-card">
                                    <div className="card-image">
                                        <img src={opportunity.image} alt={opportunity.title} />
                                    </div>
                                    <div className="card-content">
                                        <h3 className="card-title">{opportunity.title}</h3>
                                        <p className="card-description">{opportunity.description}</p>
                                    </div>
                                </div>
                            </SplideSlide>
                        ))}
                    </Splide> */}

                    <Splide
                        ref={opportunitiesRef}
                        className="opportunities-slider"
                        options={{
                            type: "loop",
                            perPage: 3, //  Show 3 slides
                            perMove: 1,
                            gap: 30,
                            arrows: false,
                            pagination: true,
                            autoplay: true,
                            speed: 800,
                            interval: 5000,
                            breakpoints: {
                                576: { perPage: 1, gap: 20 },   // Mobile
                                768: { perPage: 1, gap: 20 },   // Small tablets
                                992: { perPage: 2, gap: 25 },   // Tablets
                                1200: { perPage: 3, gap: 30 },  // Default desktop
                            },
                        }}
                    >
                        {volunteerOpportunities.map((opportunity) => (
                            <SplideSlide key={opportunity.id}>
                                <div className="opportunity-card">
                                    <div className="card-image">
                                        <img src={opportunity.image} alt={opportunity.title} />
                                    </div>
                                    <div className="card-content">
                                        <h3 className="card-title">{opportunity.title}</h3>
                                        <p className="card-description">{opportunity.description}</p>
                                    </div>
                                </div>
                            </SplideSlide>
                        ))}
                    </Splide>

                </div>
            </section>

            {/* Professional Expertise Section */}
            <section className="professional-expertise">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10 mx-auto text-center">
                            <h2 className="section-title">
                                <span className="highlight">PROFESSIONAL</span> EXPERTISE
                            </h2>

                            <div className="expertise-grid">
                                <div className="expertise-item">
                                    <div className="icon">
                                        <img src="/images/volunteer/download.png" alt="Medical Services" style={{ width: "30px", height: "30px" }} />
                                    </div>
                                    Medical Services
                                </div>

                                <div className="expertise-item">
                                    <div className="icon">
                                        <img src="/images/volunteer/download (1).png" alt="Editorial & Publishing" style={{ width: "30px", height: "30px" }} />
                                    </div>
                                    Editorial & Publishing
                                </div>

                                <div className="expertise-item">
                                    <div className="icon">
                                        <img src="/images/volunteer/download (2).png" alt="Photography & Filmmaking" style={{ width: "30px", height: "30px" }} />
                                    </div>
                                    Photography & Filmmaking
                                </div>

                                <div className="expertise-item">
                                    <div className="icon">
                                        <img src="/images/volunteer/download (3).png" alt="Architecture & Interiors" style={{ width: "30px", height: "30px" }} />
                                    </div>
                                    Architecture & Interiors
                                </div>

                                <div className="expertise-item">
                                    <div className="icon">
                                        <img src="/images/volunteer/download (4).png" alt="Graphic Design & Fine Arts" style={{ width: "30px", height: "30px" }} />
                                    </div>
                                    Graphic Design & Fine Arts
                                </div>

                                <div className="expertise-item">
                                    <div className="icon">
                                        <img src="/images/volunteer/preview.webp" alt="Drama & Performing Arts" style={{ width: "30px", height: "30px" }} />
                                    </div>
                                    Drama & Performing Arts
                                </div>

                                <div className="expertise-item">
                                    <div className="icon">
                                        <img src="/images/volunteer/preview (1).webp" alt="IT & Computer Management" style={{ width: "30px", height: "30px" }} />
                                    </div>
                                    IT & Computer Management
                                </div>

                                <div className="expertise-item">
                                    <div className="icon">
                                        <img src="/images/volunteer/preview (2).webp" alt="Social Media" style={{ width: "30px", height: "30px" }} />
                                    </div>
                                    Social Media
                                </div>
                            </div>


                            <div className="contact-info">
                                <p>
                                    For all other Volunteer Opportunities and to have any specific questions answered, please contact:
                                </p>
                                <div className="contact-details">
                                    <b>Phone: </b>
                                    <a href="tel:+919182744307">+91-9182744307</a><br />

                                    <b>WhatsApp: </b>
                                    <a href="https://wa.me/919182744307" target="_blank" rel="noopener noreferrer">
                                        +91-9182744307
                                    </a><br />

                                    <b>Email: </b>
                                    <a href="mailto:support@iskconattapur.com">
                                        support@iskconattapur.com
                                    </a>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>

            <GoToTop top={top} />
        </>
    );
};

export default VolunteerSeva;